
function slide4_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var banners = '';
  var cislo = 0;
  var coSebou = '';

  slideReset();
  changeBG("bg4");
  $('#tmi1').removeClass('active');
  $('#tmi2').removeClass('active');
  $('#tmi3').addClass('active');

  bmcont = '<div id="sl4_head"></div><div id="zalozka"></div><div id="sl4_cnt" class="sl_cnt"></div><div id="cara4" class="cara4"></div><div id="viteZe" class="viteZe" style="display:none;"><p>'+jsondata["sl4_txt1"]+'</p></div><div id="fontana" style="display:none;">'+jsondata["sl4_tlac1"]+'</div><div id="sl4_bm1" class="menu_bott_small">';
  pocet = jsondata["sl4_menu1"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id="sl4_small'+i+'" class="bmi_small" data-clicked="'+i+'"><div class="bmi_bg_small"></div><div class="bmi_point_small">';
    bmcont += '</div><div id="small'+i+'_tt" class="bmitt_small">'+jsondata["sl4_menu1"][i-1]+'</div></div>';
  }
  bmcont += '</div>';
  bmcont += '<div id="page2" class="arrowL"><i class="arrow-left"></i></div><div id="page5" class="arrowR"><i class="arrow-right"></i></div>';

  $("#slide4").html(bmcont);

  $('#slide4').fadeIn(1000);
  $('#viteZe').fadeIn(500);
  $('#fontana').fadeIn(200);
  bannerReset();
  loadBanners(5,"sl4_banner1");

  coSebou = jsondata["sl34_tlac"];
  $("#zalozka").html(coSebou);


  bannerReset();
  $(".bmi_small").on("click", function(){
		var id = $(this).attr("id");
    var clickid = $(this).data("clicked");

    bannerReset();
    clickBanner(id,5);

    $("#ban_5_"+clickid).fadeIn(100);
    var bannerBox = document.getElementById("ban_5_"+clickid);
    TweenMax.to(bannerBox, 1, {x:0, y:-486,  ease:Quint.easeOut});
    TweenMax.to(bannerBox, 0.5, {autoAlpha:1});

  });



  $("#zalozkaOpen").on("click", function(){
      bannerReset();
  		var bannerBox = document.getElementById("coSebou");
  		TweenMax.to(bannerBox, 1, {x:-570, y:-0,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });

  $("#coSebouClosed").on("click", function(){
      bannerReset();
  		var bannerBox = document.getElementById("coSebou");
  		TweenMax.to(bannerBox, 1, {x:0, y:0,  ease:Quint.easeOut});
  		TweenMax.to(bannerBox, 0.5, {autoAlpha:1});
  });

  $("#circle_pos_4_2").on("click", function(){
    bannerReset();
    slide3_anima();
  });

  $("#page2").on("click", function(){
    bannerReset();
    slide2_anima();
  });

  $("#page5").on("click", function(){
    bannerReset();
    slide5_anima();
  });

}
